import React, { useState } from "react";

const useAlert = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [resolveFunc, setResolveFunc] = useState(null);
  const [message, setMessage] = useState("");

  const alert = (msg) => {
    setMessage(msg);
    setIsOpen(true);
    return new Promise((resolve) => {
      setResolveFunc(() => resolve);
    });
  };

  const handleConfirm = () => {
    setIsOpen(false);
    if (resolveFunc) {
      resolveFunc();
    }
    setResolveFunc(null);
  };

  const AlertDialog = () => {
    if (!isOpen) return null;
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
        <div className="bg-secondary/90 rounded-[32px] shadow-lg w-full max-w-sm p-6 flex flex-col gap-2 border border-white/10 backdrop-blur-lg ">
          <div>
            <h2 className="text-xl text-background font-bold mb-2 font-nunito leading-5">
              Alert
            </h2>
            <p className="mb-4 text-background/70 leading-5">{message}</p>
          </div>
          <div className="flex justify-end">
            <button
              onClick={handleConfirm}
              className="px-4 py-2  rounded-xl bg-primary/90 text-secondary font-nunito hover:bg-primary font-semibold backdrop-blur-sm border border-white/10"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    );
  };

  return { alert, AlertDialog };
};

export default useAlert;
